export { ChatDock } from "./ChatDock";
export { ChatDockProvider, useChatDock, useOptionalChatDock } from "./ChatDockContext";
export { getChatTargetKey } from "./chatDock.types";
export type { ChatTarget, OpenChat } from "./chatDock.types";
export {
  buildChatDockLabel,
  resolveGroupChatName,
  resolveInternalChatName,
  resolveJobChatName,
  resolveSmsChatName,
} from "./helpers/resolveChatLabel";
